/**
 * Who the workspace will listen to — spec 013 §10.4.
 *
 * Its own function so the rule is testable without a cross-origin iframe, which jsdom
 * cannot provide. Compared as an **origin**, never by prefix: `notviewer.example.com`
 * ends with the viewer's host and is a different site, and `http://` is a different
 * origin from `https://` at the same host.
 */
export function viewerOrigin(
  viewerUrl: string | undefined,
): string | undefined {
  if (viewerUrl === undefined) return undefined;

  try {
    return new URL(viewerUrl).origin;
  } catch {
    return undefined;
  }
}

/** The same origin the payload is posted to — computed once, so the two cannot disagree. */
export function isFromViewer(
  origin: string,
  viewerUrl: string | undefined,
): boolean {
  const expected = viewerOrigin(viewerUrl);

  return expected !== undefined && origin === expected;
}
